import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";

type InitiateSwishPaymentError = {
    readonly _id: string;
    readonly _type: "SWISH_INITIATE_PAYMENT_ERROR";
    readonly _createdAt: IsoAndUnixTimestamp;
    //Customer facing
    readonly reason: string;
    //Tech explanation
    readonly explanation: string;
    readonly swishErrorCode: string;
};

type FactoryParams = Except<
    InitiateSwishPaymentError,
    "_id" | "_createdAt" | "_type"
>;
const initiateSwishPaymentErrorFactory = (
    params: FactoryParams,
): InitiateSwishPaymentError => {
    return {
        _id: generateId({ prefix: "swish_initiate_payment_error__" }),
        _createdAt: nowIsoAndUnix(),
        _type: "SWISH_INITIATE_PAYMENT_ERROR",
        ...params,
    };
};

const initiateSwishPaymentErrorZodSchema: z.ZodSchema<InitiateSwishPaymentError> =
    z.object({
        _id: z.string(),
        _createdAt: isoAndUnixZodSchema,
        _type: z.literal("SWISH_INITIATE_PAYMENT_ERROR"),
        reason: z.string(),
        explanation: z.string(),
        swishErrorCode: z.string(),
    });

export { initiateSwishPaymentErrorFactory, initiateSwishPaymentErrorZodSchema };
export type {
    FactoryParams as CreateInitiateSwishPaymentErrorParams,
    InitiateSwishPaymentError,
};
